import axios from "axios";

interface GameHelpPageResponseModel {
    title: string;
    text: string;
}

export async function showGameHelpPopup(gameId: number) {
    let modalElement = $(`#game-help-${gameId}`);
    if (modalElement.length > 0) {
        modalElement.modal("show");
    } else {
        const response = await axios.get<GameHelpPageResponseModel>(`/api/casino/help-page/${gameId}`);
        const help = response.data;

        $(document.body).append(
            `<div class="modal modal-game-help" id="game-help-${gameId}" tabindex="-1" role="dialog">
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-body">
                            <button type="button" class="btn-close" data-dismiss="modal">Zavřít</button>
                            <h2 class="modal-game-help__title">${help.title}</h2>
                            ${help.text}
                        </div>
                    </div>
                </div>
            </div>`
        );
        modalElement = $(`#game-help-${gameId}`).modal("show");
    }
}
